<app-header></app-header>
<app-sidebar></app-sidebar>
<div class="content-wrapper" style="min-height: 307px">
    <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="timer" [fullScreen]="false">
        <p style="color: white">Loading... </p>
    </ngx-spinner>
    <!-- แบบบันทึกทั้งหมดนั่นล่ะ -->
    <div class="card">
        <div class="card-header bg-primary">แบบฟอร์มขอเบิกปัจจัย {{year[3]}}</div>
        <div class="card-body">
            <!--<form [formGroup]="Formfactor">
                    <div *ngIf="famerlist != null">
                        <div class="input-group mb-3 col-7">
                            <span class="input-group-text" id="basic-addon1">เลือกชาวไร่</span>
                            <input type="text" class="form-control" placeholder="ป้อนรหัสโควตา" list="farmer"
                                 [(ngModel)]="fmcode" id="codefm"
                                (change)="goloaddata()">
                            <datalist id="farmer" style="width: 500px;">
                                <option *ngFor="let item of famerlist">
                                    [{{item.fmcode_b1}}] {{item.fmname}} จำนวนแปลง {{item.cnt}}
                                    <lable *ngIf="item.approve=='Y'">เบิกได้</lable>
                                    <lable *ngIf="item.PromiseIN == 0">สัญญายังไม่ผ่าน</lable>
                                    <lable *ngIf="item.zoneban =='Y' ">อยู่โซนต้องห้าม</lable>
                                </option>
                            </datalist>
                            <div class="input-group-prepend">
                                <span class="input-group-text">
                                    <input class="form-check-input" type="checkbox"
                                         [(ngModel)]="ckcash" name="cash0"
                                        (change)="ckack()">เงินสด
                                </span>
                            </div>
                            <button class="btn btn-default float-right" (click)="clearFm();">กรอกใหม่</button>
                        </div>
                    </div>
                </form>-->
            <div class="row">
                <div class="col-md-5 ml-md">
                    <mat-form-field appearance="outline" *ngIf="famerlist2.length>0">
                        <mat-label>เลือกชาวไร่</mat-label>
                        <mat-select required [(ngModel)]="fmcode" (ngModelChange)="goloaddata()">
                            <mat-form-field class="example-form-field" appearance="outline">
                                <mat-label>ค้นหา -*เลือกชาวไร่*-</mat-label>
                                <input matInput type="text" [(ngModel)]="txtFindIn" focus
                                    (ngModelChange)="search_dataFM()">
                                <button *ngIf="txtFindIn" matSuffix mat-icon-button aria-label="Clear"
                                    (click)="txtFindIn=''"><mat-icon>close</mat-icon></button>
                            </mat-form-field>
                            <mat-option *ngFor="let item of famerlist; let i = index;" [value]="item.fmcode_b1">
                                {{i+1}}.[{{ item.fmcode_b1 }}]-{{ item.fmname }}, {{ item.cnt }} แปลง,
                                โซน-{{ item.SUPZONE }}
                                <lable *ngIf="item.approve=='Y'">เบิกได้</lable>
                                <lable *ngIf="item.PromiseIN==0">สัญญายังไม่ผ่าน</lable>
                                <lable *ngIf="item.zoneban=='Y'">อยู่โซนต้องห้าม</lable>
                            </mat-option>
                            <mat-option *ngIf="famerlist.length==0" [value]="" disabled>.--ไม่พบข้อมูล--.</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-sm-1 ml-md">
                    <section>
                        <mat-checkbox color="warn" [(ngModel)]="ckcash" (ngModelChange)="ckack()"> เงินสด
                        </mat-checkbox>
                    </section>
                </div>
                <div class="col-sm-1 ml-md">
                    <button mat-button (click)="clearFm();">กรอกใหม่</button>
                </div>
            </div>

            <div class="col-md-9 ml-md">
                <table style="width:100%">
                    <tr style="text-align:center">
                        <th>หลักทรัพย์ค้ำประกัน/คงเหลือ</th>
                        <!--<th>ยอดหนี้ปี {{year[2]}}</th>-->
                        <th>วงเงินที่ใช้ไป</th>
                        <th>ขอเกี้ยว </th>
                        <th>เบิกปัจจัย</th>
                        <th>วงเงินปุ๋ย/คงเหลือ</th>
                        <th>วงเงินปัจจัย/คงเหลือ</th>

                    </tr>
                    <tr style="text-align:center">
                        <td>{{credit|number}}/<b style="color: red;">{{limit|number}}</b></td>
                        <!--<td>{{RSUM_long|number}}</td>-->
                        <td>{{sum_money_amt|number}}</td>
                        <td>{{sum_money_amt1|number}}</td>
                        <td>{{sum_money_amt2|number}}</td>
                        <td>{{sum_balance.tofert|number}}/<b style="color: red;">{{sum_balance.balance_amt1|number}}</b>
                        </td>
                        <td>{{sum_balance.sum_toget|number}}/
                            <b style="color: red;">{{sum_balance.sum_balance|number}}</b>
                        </td>
                    </tr>
                </table>
            </div>

            <div class="row justify-content-md-center">
                <!-- รายการชาวไร่  -->
                <div class="col-md">
                    <div class="card">
                        <div class="card-body table-responsive p-2" style="height: 650px">
                            <table #tb_data class="table table-head-fixed table-striped ">
                                <thead>
                                    <tr class="headText text-primary" style="text-align:center">
                                        <th>.</th>
                                        <th>เลขแปลง</th>
                                        <th>โซน/รูท</th>
                                        <th>ประเภท</th>
                                        <th>พื้นที่</th>
                                        <th>ตัน/ไร่</th>
                                        <!--<th>เบิกได้</th>-->
                                        <th>เบิกแล้ว</th>
                                        <th>วงเงินปุ๋ย/คงเหลือ</th>
                                        <th>เลือก</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let item of dataonefarmer; let i = index;" style="text-align:center">
                                        <td>{{i+1}}</td>
                                        <td>{{item.intlandno}}</td>
                                        <td>{{item.supzone}}/{{item.route}}</td>
                                        <td>{{item.canetype}}</td>
                                        <td>{{item.landvalue | number:'1.2-2' }}</td>
                                        <td>{{item.Ton | number:'1.0-1' }}</td>
                                        <!--<td>{{item.caneGetfert12}}</td>-->
                                        <td>{{item.Getferted}}</td>
                                        <td>{{item.tofert|number}}/{{item.balance_amt1|number}}</td>
                                        <td>
                                            <button class="btn btn-success btn-sm" (click)="Selectoneplant([item]);"
                                                *ngIf="!ckfarmercan">
                                                <i class="fa fa-arrow-circle-right"></i>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <!-- รายการชาวไร่  -->

                <!-- ฟอร์มบันทึกกรอกปัจจัย -->
                <div class="col-md" [hidden]="ckfarmercan">
                    <div class="card">
                        <div class="card-header bg-warning"> ฟอร์มขอเบิกปัจจัยการผลิตปี {{year[2]}} ({{famername}})
                        </div>
                        <div class="card-body" *ngIf="oneplant.length>0">
                            <table class="table-head-fixed " cellspacing="0" style="width: 100%">
                                <tr style="text-align:center">
                                    <td style="width: 30%">
                                        <mat-form-field appearance="fill">
                                            <mat-label>สต๊อก</mat-label>
                                            <mat-select required [(ngModel)]="localstock"
                                                (selectionChange)="Change_amt(0)">
                                                <mat-option [value]="" disabled>กรุณาเลือกสต๊อก</mat-option>
                                                <mat-option *ngFor="let item of fertilizerstock"
                                                    [value]="item.StockID">สต๊อก-{{item.Stockname}}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </td>
                                    <td style="width: 40%"><a> แปลง {{intlandno}}</a>
                                        <!--<input type="text" class="form-control" [value]="intlandno" disabled></td>-->
                                    <td style="width: 30%"><a> ประเภทอ้อย {{detailsplant}} ไร่</a></td>
                                </tr>
                            </table>

                            <!--<table #tb_data class="table table-hover table-head-fixed text-nowrap" style="width:100%;">-->
                            <div class="card" *ngIf="localstock!=''">
                                <table class="table-head-fixed " cellspacing="0" style="width: 100%;">
                                    <tr class="headText text-primary" style="text-align:center">
                                        <!--<th style="width:10%"></th>-->
                                        <th colspan="2" style="width:45%;">รหัสสินค้า</th>
                                        <th scope="col" style="width:10%;">ราคา</th>
                                        <th scope="col" style="width:11%;">จำนวน</th>
                                        <th scope="col" style="width:8%;">เบิกแล้ว</th>
                                        <th scope="col" style="width:15%;">วงเงิน/คงเหลือ</th>
                                        <th scope="col" style="width:11%;">ราคา*</th>
                                    </tr>
                                    <tr style="text-align:center">
                                        <!--<td>ปุ๋ยเคมี</td>-->
                                        <td colspan="2">
                                            <mat-form-field appearance="fill">
                                                <mat-label>ปุ๋ยเคมี</mat-label>
                                                <mat-select required [(ngModel)]="list_doc.cemecal"
                                                    (selectionChange)="ChangeValue(1)">
                                                    <mat-form-field class="example-form-field" appearance="fill">
                                                        <mat-label>ค้นหา -*ปุ๋ยเคมี*-</mat-label>
                                                        <input matInput type="text" style="text-align:center"
                                                            [(ngModel)]="txtSearch[1]">
                                                        <button *ngIf="txtSearch[1]" matSuffix mat-icon-button
                                                            aria-label="Clear"
                                                            (click)="txtSearch[1]=''"><mat-icon>close</mat-icon>
                                                        </button>
                                                    </mat-form-field>
                                                    <mat-option [value]="['',0,0,0,'']" selected>+++
                                                        ไม่เลือกปุ๋ยเคมี +++</mat-option>
                                                    <mat-option *ngFor="let item of stock_d1 | filter:txtSearch[1]"
                                                        [value]="[item.stock_id,item.per_unit,item.amt_in,item.amt_out,item.description]">[{{item.stock_id}}]
                                                        | {{item.description}}</mat-option>
                                                </mat-select>
                                                <mat-hint>{{cemecal.name}}</mat-hint>
                                            </mat-form-field>
                                        </td>
                                        <td>{{cemecal.amt | number}}</td>
                                        <td>
                                            <input matInput type="number" min="0" [(ngModel)]="cemecal.amt_val"
                                                style="background-color:#faf3cc;text-align:center;width: 70px;"
                                                (change)="Change_amt(1)">
                                        </td>
                                        <td value="0">
                                            {{oneplant[0].Getferted | number}}
                                        </td>
                                        <td value="0">
                                            {{oneplant[0].tofert| number}}/{{oneplant[0].balance_amt1| number}}
                                        </td>
                                        <td>{{cemecal.amt_last | number}}</td>
                                        <hr>
                                    </tr>
                                    <tr style="text-align:center">
                                        <!--<td>ปุ๋ยอินทรีย์</td>-->
                                        <td colspan="2">
                                            <mat-form-field appearance="fill">
                                                <mat-label>ปุ๋ยอินทรีย์</mat-label>
                                                <mat-select required [(ngModel)]="list_doc.organic"
                                                    (selectionChange)="ChangeValue(2)" [disabled]="getFert3">
                                                    <mat-form-field class="example-form-field" appearance="fill">
                                                        <mat-label>ค้นหา -*ปุ๋ยอินทรีย์*-</mat-label>
                                                        <input matInput type="text" style="text-align:center"
                                                            [(ngModel)]="txtSearch[2]">
                                                        <button *ngIf="txtSearch[2]" matSuffix mat-icon-button
                                                            aria-label="Clear"
                                                            (click)="txtSearch[2]=''"><mat-icon>close</mat-icon>
                                                        </button>
                                                    </mat-form-field>
                                                    <mat-option [value]="['',0,0,0,'']" selected>+++
                                                        ไม่เลือกปุ๋ยอินทรีย์ +++</mat-option>
                                                    <mat-option *ngFor="let item of stock_d2 | filter:txtSearch[2]"
                                                        [value]="[item.stock_id,item.per_unit,item.amt_in,item.amt_out,item.description]">[{{item.stock_id}}]
                                                        | {{item.description}}</mat-option>
                                                </mat-select>
                                                <mat-hint>{{organic.name}}</mat-hint>
                                            </mat-form-field>
                                        </td>
                                        <td>{{organic.amt | number}}</td>
                                        <td>
                                            <input matInput type="number" min="0" [disabled]="getFert3"
                                                [(ngModel)]="organic.amt_val"
                                                style="background-color:#faf3cc;text-align:center;width: 70px;"
                                                (change)="Change_amt(2)">

                                        </td>
                                        <td value="0">
                                            {{oneplant[0].GetOrganic| number}}
                                        </td>
                                        <td value="0">
                                            {{oneplant[0].toget2| number}}/{{oneplant[0].balance_amt2| number}}
                                        </td>
                                        <td>{{organic.amt_last | number }}</td>
                                        <hr>
                                    </tr>

                                    <tr style="text-align:center">
                                        <!--<td>โดโลไมท์</td>-->
                                        <td colspan="2">
                                            <mat-form-field appearance="fill">
                                                <mat-label>โดโลไมท์</mat-label>
                                                <mat-select required [(ngModel)]="list_doc.dolomite"
                                                    (selectionChange)="ChangeValue(3)" [disabled]="getFert3">
                                                    <mat-form-field class="example-form-field" appearance="fill">
                                                        <mat-label>ค้นหา -*โดโลไมท์*-</mat-label>
                                                        <input matInput type="text" style="text-align:center"
                                                            [(ngModel)]="txtSearch[3]">
                                                        <button *ngIf="txtSearch[3]" matSuffix mat-icon-button
                                                            aria-label="Clear"
                                                            (click)="txtSearch[3]=''"><mat-icon>close</mat-icon></button>
                                                    </mat-form-field>
                                                    <mat-option [value]="['',0,0,0,'']" selected>+++
                                                        ไม่เลือกโดโลไมท์ +++</mat-option>
                                                    <mat-option *ngFor="let item of stock_d4 | filter:txtSearch[3]"
                                                        [value]="[item.stock_id,item.per_unit,item.amt_in,item.amt_out,item.description]">[{{item.stock_id}}]
                                                        | {{item.description}}</mat-option>
                                                </mat-select>
                                                <mat-hint>{{dolomite.name}}</mat-hint>
                                            </mat-form-field>

                                        </td>
                                        <td>{{dolomite.amt | number}}</td>
                                        <td>
                                            <input matInput type="number" min="0" [disabled]="getFert3"
                                                [(ngModel)]="dolomite.amt_val"
                                                style="background-color:#faf3cc;text-align:center;width: 70px;"
                                                (change)="Change_amt(3)">
                                        </td>
                                        <td value="0">
                                            {{oneplant[0].GetDolomite| number}}
                                        </td>
                                        <td value="0">
                                            {{oneplant[0].toget4| number}}/{{oneplant[0].balance_amt4| number}}
                                        </td>
                                        <td>{{dolomite.amt_last | number }}</td>
                                        <hr>
                                    </tr>

                                    <tr style="text-align:center">
                                        <!--<td>ยา</td>-->
                                        <td colspan="2">
                                            <mat-form-field appearance="fill">
                                                <mat-label>ยา</mat-label>
                                                <mat-select required [(ngModel)]="list_doc.medical"
                                                    (selectionChange)="ChangeValue(4)" [disabled]="getFert3">
                                                    <mat-form-field class="example-form-field" appearance="fill">
                                                        <mat-label>ค้นหา -*ยา*-</mat-label>
                                                        <input matInput type="text" style="text-align:center"
                                                            [(ngModel)]="txtSearch[4]">
                                                        <button *ngIf="txtSearch[4]" matSuffix mat-icon-button
                                                            aria-label="Clear"
                                                            (click)="txtSearch[4]=''"><mat-icon>close</mat-icon></button>
                                                    </mat-form-field>
                                                    <mat-option [value]="['',0,0,0,'']" selected>+++
                                                        ไม่เลือกรายการยา +++</mat-option>
                                                    <mat-option *ngFor="let item of stock_d3 | filter:txtSearch[4]"
                                                        [value]="[item.stock_id,item.per_unit,item.amt_in,item.amt_out,item.description]">[{{item.stock_id}}]
                                                        | {{item.description}}</mat-option>
                                                </mat-select>
                                                <mat-hint>{{medical.name}}</mat-hint>
                                            </mat-form-field>

                                        </td>
                                        <td>{{medical.amt | number}}</td>
                                        <td>
                                            <input matInput type="number" min="0" [disabled]="getFert3"
                                                [(ngModel)]="medical.amt_val"
                                                style="background-color:#faf3cc;text-align:center;width: 70px;"
                                                (change)="Change_amt(4)">

                                            <!--<div class="input-group mb-3">
                                                <input type="number" min="0" class="form-control"  [(ngModel)]="amt_val4" id="countmedi" (change)="Change_amt(4)" style="text-align:center" 
                                                [ngClass]="{ 'is-invalid': submitted && factor.countmedical.errors }" value="0">                                                
                                            </div>-->
                                        </td>
                                        <td></td>
                                        <td value="0">
                                            {{oneplant[0].toget3| number}}/{{oneplant[0].balance_amt3| number}}
                                        </td>
                                        <td>{{medical.amt_last | number }}</td>
                                        <hr>
                                    </tr>

                                    <tr style="text-align:center">
                                        <!--<td>อุปกรณ์</td>-->
                                        <td colspan="2">
                                            <mat-form-field appearance="fill">
                                                <mat-label>อุปกรณ์</mat-label>
                                                <mat-select required [(ngModel)]="list_doc.machine"
                                                    (selectionChange)="ChangeValue(5)" [disabled]="getFert3">
                                                    <mat-form-field class="example-form-field" appearance="fill">
                                                        <mat-label>ค้นหา -*อุปกรณ์*-</mat-label>
                                                        <input matInput type="text" style="text-align:center"
                                                            [(ngModel)]="txtSearch[5]">
                                                        <button *ngIf="txtSearch[5]" matSuffix mat-icon-button
                                                            aria-label="Clear"
                                                            (click)="txtSearch[5]=''"><mat-icon>close</mat-icon></button>
                                                    </mat-form-field>
                                                    <mat-option [value]="['',0,0,0,'']" selected>+++ ไม่เลือกอุปกรณ์
                                                        +++</mat-option>
                                                    <mat-option *ngFor="let item of stock_d5 | filter:txtSearch[5]"
                                                        [value]="[item.stock_id,item.per_unit,item.amt_in,item.amt_out,item.description]">[{{item.stock_id}}]
                                                        | {{item.description}}</mat-option>
                                                </mat-select>
                                                <mat-hint>{{machine.name}}</mat-hint>
                                            </mat-form-field>
                                        </td>
                                        <td>{{machine.amt | number}}</td>
                                        <td>
                                            <input matInput type="number" min="0" [disabled]="getFert3"
                                                [(ngModel)]="machine.amt_val"
                                                style="background-color:#faf3cc;text-align:center;width: 70px;"
                                                (change)="Change_amt(5)">
                                        </td>
                                        <td></td>
                                        <td></td>
                                        <td>{{machine.amt_last | number }}</td>
                                        <hr>
                                    </tr>

                                    <tfoot>
                                        <tr style="text-align:center">
                                            <td style="text-align:center">
                                                <section>
                                                    <mat-checkbox color="warn" [(ngModel)]="ckcash"
                                                        (ngModelChange)="ckack()">
                                                        เงินสด
                                                    </mat-checkbox>
                                                </section>
                                            </td>
                                            <td>
                                                <section *ngIf="ck_Fert3">
                                                    <mat-checkbox [(ngModel)]="getFert3" (ngModelChange)="if_getFert3()"
                                                        [disabled]="ckfarmercan">
                                                        เบิกปุ๋ยรอบ 3
                                                    </mat-checkbox>
                                                </section>
                                            </td>
                                            <td colspan="2" style="color: red;">
                                                <!--หากไม่ได้เบิกส่วนอื่น ๆ ให้เลือก ไม่เลือกรายการ ให้กรอกจำนวน 0-->
                                            </td>
                                            <td colspan="2" style="text-align:right">รวมทั้งหมด | </td>
                                            <td style="color: red;" scope="row">{{sum_amtlast | number }}</td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                            <div>
                                <button class="btn btn-info float-left" (click)="Savedatafactor();"
                                    *ngIf="localstock.length>0 &&!ckfarmercan && oneplant.length>0">บันทึก</button>

                                <button class="btn btn-warning float-right" (click)="cleardata();">กรอกใหม่</button>
                            </div>

                        </div>
                    </div>
                </div>
                <!-- ฟอร์มบันทึกกรอกปัจจัย -->
            </div>
        </div>
        <!-- แบบบันทึกทั้งหมดนั่นล่ะ -->
        <!--  รายการแสดงเบิกปัจจัย -->

        <div class="card">
            <div class="card-header">
                <i class="fas fa-table"></i> ข้อมูลการเบิกปัจจัย ปี {{year[2]}} ({{famername}})
            </div>
            <div class="card-body table-responsive p-2" style="height: 600px">
                <table class="table table-hover table-head-fixed table-striped">
                    <thead>
                        <tr class="headText text-primary text-center">
                            <th>_</th>
                            <th>เลขที่ </th>
                            <th>วันที่</th>
                            <th>ชื่อ</th>
                            <th>แปลง</th>
                            <th>รายการ</th>
                            <th>สต็อค</th>
                            <th>ราคารวม</th>
                            <th>พิมพ์</th>
                            <th>ยกเลิก</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="text-center" *ngFor="let data of onecode; let i = index;">
                            <td>{{i+1}}</td>
                            <td style="text-align:left">{{data.docid }} <b *ngIf="data.take_method == 1"
                                    style="color: red;">(เงินสด)</b><b *ngIf="data.getFert3 == 'Y'"
                                    style="color: red;">ปุ๋ยรอบ3</b></td>
                            <td>{{data.datepost_th}}</td>
                            <td>{{data.fmname}}</td>
                            <td>{{data.intlandno}}</td>
                            <td style="text-align:left">
                                <mat-label *ngIf="data.amt1>0">- {{data.desc1}} *
                                    <span class="badge badge-pill badge-primary"> {{data.amt1}} </span> -</mat-label>
                                <mat-label *ngIf="data.amt2>0">- {{data.desc2}} *
                                    <span class="badge badge-pill badge-primary"> {{data.amt2}} </span> -</mat-label>
                                <mat-label *ngIf="data.amt4>0">- {{data.desc4}} *
                                    <span class="badge badge-pill badge-primary"> {{data.amt4}} </span> -</mat-label>
                                <mat-label *ngIf="data.amt3>0">- {{data.desc3}} *
                                    <span class="badge badge-pill badge-primary"> {{data.amt3}} </span> -</mat-label>
                                <mat-label *ngIf="data.amt5>0">- {{data.desc5}} *
                                    <span class="badge badge-pill badge-primary"> {{data.amt5}} </span> -</mat-label>
                            </td>
                            <td>{{data.Stockname}}</td>
                            <td style="text-align:right">{{data.money_amt | number}}</td>
                            <td>
                                <a [routerLink]="['/docfertilizer/'+year[1]+'/'+data.fmcode+'/'+data.docid+'/0']"
                                    routerLinkActive="active" target="_blank"><i class="fas fa-print"></i>
                                </a>
                            </td>
                            <td><a (click)="cancledata(data)"> <i class="far fa-window-close" style='color:red'></i></a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <!--  รายการแสดงเบิกปัจจัย -->
    </div>
</div>
<app-footer></app-footer>